module.exports = __webpack_public_path__ + "media/images/menu/eris-665b97855b72c30f9feb098ac49f312f.jpg";